// Form field name constants — shared across assignment modal files
export const FIELD_USER_ID = 'userId' as const;
export const FIELD_PROJECT_ID = 'projectId' as const;
export const FIELD_SCHEDULED_WORK = 'scheduledWork' as const;
export const FIELD_DATE_RANGE = 'dateRange' as const;
export const FIELD_DATE_RANGE_FROM = 'dateRange.from' as const;
export const FIELD_DATE_RANGE_TO = 'dateRange.to' as const;
export const FIELD_STATUS = 'status' as const;
export const FIELD_PROBABILITY = 'probability' as const;
export const FIELD_RATE_SOURCE = 'rateSource' as const;
export const FIELD_RATE = 'rate' as const;
export const FIELD_CURRENCY = 'currency' as const;
export const FIELD_IS_BILLABLE = 'isBillable' as const;
export const FIELD_DO_SKIP_WEEKDAYS = 'doSkipWeekdays' as const;
export const FIELD_IS_BACKGROUND_WORK = 'isBackgroundWork' as const;
export const FIELD_NOTE = 'note' as const;

export const DEFAULT_SCHEDULED_WORK = '08:00';

export const TEAM_MEMBERS_QUERY_KEY = 'team-members-short';
export const PROJECTS_QUERY_KEY = ['short-projects'];
